var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.privilegios)?_c('div',{staticClass:"wrapper"},[_c('notifications'),_c('side-bar',[_c('template',{slot:"links"},[_c('sidebar-item',{attrs:{"link":{
          name: 'Panel Principal',
          path: '/dashboard',
          icon: 'ni ni-tv-2 text-primary',
        }}}),(_vm.privilegios == 'SU' || _vm.privilegios == 'C')?_c('sidebar-item',{attrs:{"link":{
          name: 'Gestión',
          path: '/gestion_grupos',
          icon: 'ni ni-planet text-blue',
        }}},[_c('sidebar-item',{attrs:{"link":{
            name: 'Gestion Catequesis',
            path: '/gestion_grupos',
            icon: 'ni ni-planet text-blue',
          }}}),_c('sidebar-item',{attrs:{"link":{
            name: 'Gestion Catecumenos',
            path: '/gestionCatecumenos',
            icon: 'ni ni-planet text-blue',
          }}})],1):_vm._e(),_c('sidebar-item',{attrs:{"link":{
          name: 'User Profile',
          path: '/profile',
          icon: 'ni ni-single-02 text-yellow',
        }}}),(_vm.privilegios == 'SU')?_c('sidebar-item',{attrs:{"link":{
          name: 'Gestión de Usuarios',
          path: '/gestionUsuarios',
          icon: 'ni ni-circle-08 text-green',
        }}}):_vm._e(),(_vm.privilegios == 'SU')?_c('sidebar-item',{attrs:{"link":{
          name: 'Register',
          path: '/register',
          icon: 'ni ni-circle-08 text-pink',
        }}}):_vm._e()],1),_c('template',{slot:"links-after"})],2),_c('div',{staticClass:"main-content"},[_c('dashboard-navbar',{attrs:{"type":_vm.$route.meta.navbarType}}),_c('div',{on:{"click":function($event){return _vm.$sidebar.displaySidebar(false)}}},[_c('fade-transition',{attrs:{"duration":200,"origin":"center top","mode":"out-in"}},[_c('router-view')],1)],1)],1)],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }